import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'date',
  standalone: true,
})
export class LanguageDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, pattern: string = 'short'): string | null {
    const datePipe = new DatePipe(
      this.translateService.currentLang === 'translationKeys'
        ? 'en-GB'
        : this.translateService.currentLang
    );
    return datePipe.transform(value, pattern);
  }
}
